import { configureStore } from '@reduxjs/toolkit';
import appSliceReducer from './app/app-slice';

export const store = configureStore({
    reducer: {
        app: appSliceReducer,
    }
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
